import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { env } from "@/config";
import { coreApi } from "@/conection";
import { AuthModule } from "@/store/modules/Auth";
import { onMounted, ref } from "vue";
import Table from "@/components/TablePaginated.vue";
import { ElDialog, ElTabs, ElTabPane } from "element-plus";
import { DateTime, Duration } from "ts-luxon";
import { ro } from "date-fns/locale";


export default /*#__PURE__*/_defineComponent({
  props: {
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean }

const tab = ref('pauses');
const loading1 = ref(false);
const loading2 = ref(false);
const pausesTableData = ref({
	totalDocs: 0,
	th: [
		{
			text: "Pausa",
			value: "razon",
		},
		{
			text: "Tiempo en pausa",
			value: "duration",
			formatter: (row: any) =>
				Duration.fromObject({ milliseconds: row.duration }).toFormat('hh:mm:ss')
		},
	],
	td: [] as any[],
})

const generalTableData = ref({
	totalDocs: 0,
	th: [
		{
			text: "",
			value: "text",
			formatter: (row: any) => {
				return row.text === 'LOGIN'
					? 'Tiempo conectado'
					: row.text === 'READY'
						? 'Tiempo disponible'
						: row.text
			}
		},
		{
			text: "",
			value: "value",
			formatter: (row: any) => {
				return row?._id ?? false
					? Duration.fromObject({ milliseconds: row.value }).toFormat('hh:mm:ss')
					: typeof row.value !== 'number'
						? DateTime.fromISO(row.value).toFormat('dd-MM-yyyy hh:mm:ss')
						: row.value
			}
		},
	],
	td: [] as any[],
})




const loadPausesInfo = () => {
	loading1.value = true
	coreApi.get(`${env.CoreApi}/api/events/pauses/agent`, {
		headers: {
			"access-token": AuthModule.token ?? ""
		}
	}).then(response => {
		pausesTableData.value.td = response.data.pauseSummary
		pausesTableData.value.totalDocs = response.data.pauseSummary.length ?? 0
	}).finally(() => loading1.value = false)
}

const loadGeneralInfo = () => {
	loading2.value = true
	coreApi.get(`${env.CoreApi}/api/events/events/agent`, {
		headers: {
			"access-token": AuthModule.token ?? ""
		}
	}).then(response => {
		generalTableData.value.td = response.data.summary
		generalTableData.value.totalDocs = response.data.summary.length ?? 0
	}).finally(() => loading2.value = false)
}

const tabChange = (tab: any) => {
	if(tab === 'pauses')
		loadPausesInfo()

	if(tab === 'general')
		loadGeneralInfo()
}

onMounted(() => {
	loadPausesInfo()
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: __props.show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : null)),
    title: "Tus estadisticas",
    "body-class": "p-0",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emits('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ElTabs), {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        onTabChange: tabChange,
        stretch: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTabPane), {
            label: "Pausas",
            name: "pauses"
          }, {
            default: _withCtx(() => [
              _createVNode(Table, {
                "card-class": "shadow-none rounded",
                tableData: pausesTableData.value,
                tittle: "Resumen de las pausas",
                load: loading1.value
              }, null, 8, ["tableData", "load"])
            ]),
            _: 1
          }),
          _createVNode(_unref(ElTabPane), {
            label: "Datos generales",
            name: "general"
          }, {
            default: _withCtx(() => [
              _createVNode(Table, {
                "card-class": "shadow-none rounded",
                tableData: generalTableData.value,
                tittle: "Datos generales",
                load: loading2.value
              }, null, 8, ["tableData", "load"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})